import { AbstractControl, ValidationErrors, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { debounceTime, map, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';

export function phone10DigitsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    // Si es un string, usarlo directamente; si es un objeto, usar la propiedad number
    const phoneNumber = typeof value === 'string' 
      ? value.replace(/\D/g, '') 
      : (value?.number?.replace(/\D/g, '') || '');
    
    if (!phoneNumber) return null;

    // Elimina código de país y valida solo los 10 dígitos
    const withoutCountryCode = phoneNumber.replace(/^52/, ''); // Si empieza con 52, lo quita

    return withoutCountryCode.length === 10 ? null : { invalidLength: true };
  };
}

export function validatePhoneExistence(candidatosApiService: CandidatosApiService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    const phone = control.value;
    if (!phone) return of(null);

    // Si es un string, usarlo directamente; si es un objeto, usar la propiedad number
    const phoneNumber = typeof phone === 'string' 
      ? phone.replace(/\s+/g, '').replace(/\D/g, '')
      : (phone?.number?.replace(/\s+/g, '') || '');

    if (!phoneNumber) return of(null);

    console.log(">?>>>>>control", phoneNumber);
    
    return of(phoneNumber).pipe(
      debounceTime(300),
      take(1),
      switchMap(() => candidatosApiService.validatePhoneNumberService(phoneNumber)),
      map(existe => (existe.codigo!=404 ? { celularExistente: true } : null))
    );
  };
}